import BaseService from '../../BaseService.js'

export default class AbfragenService extends BaseService {

  constructor() {
    super('abfragen')
  }
}
